module.exports = __webpack_public_path__ + "static/elephants-2-1adef39b722119fcccb8ce4c04ef693a.jpg";